/**
 * KLine的KDJ
 */
import {
  LINE_TYPE,
} from '../../viewmodel/setting.js';
import BaseContext from '../basecontext';
import KLineFootDectorator from '../dectorator/klinefootdectorator';
import { checkMainAuth, checkMainTitleAuth } from '../../viewmodel/dectorator/checkauthdectorator/index.js';
import Util, { mergeModelData, curryFun } from '../../util/index.js';
const model = {
  k: {
    Type: Array,
    Default: () => ([])
  },
  d: {
    Type: Array,
    Default: () => ([])
  },
  j: {
    Type: Array,
    Default: () => ([])
  },
  params: {
    Type: String,
    Default: 'KDJ(9,3,3)'
  }
};
export default class KLineKDJState extends KLineFootDectorator(BaseContext) {
  constructor({ data, ...rest }) {
    super({ ...rest, data: mergeModelData(model, data) });
  }
  _calcRange() {
    const { k, d, j, params } = this.state.data;
    let { maxValue, minValue } = this.calcRange({ data: [k, d, j], targetKey: 'value', isAdditional: true });
    // if (maxValue === minValue) {
    //   if (maxValue === 0) {
    //     maxValue = 1;
    //     minValue = -1;
    //   } else if (maxValue === 100) {
    //     maxValue = 150;
    //     minValue = 50;
    //   }
    // } else {
    //   const ratioVal = maxValue * 0.05;
    //   maxValue += ratioVal;
    //   minValue -= ratioVal;
    // }
    this.maxValue = maxValue;
    this.minValue = minValue;
  }
  _calcAxis() {
    const { k, d, j } = this.state.data;
    const curryCalcAxis = curryFun(this.calcAxis, this, {
      targetKey: 'value',
      sourceKey: 'lineY',
      isAdditional: true,
    });
    curryCalcAxis({ data: k });
    curryCalcAxis({ data: d });
    curryCalcAxis({ data: j });
  }
  _drawMain() {
    const {
      left,
      bottom,
      width
    } = this.availArea;
    const { k, d, j } = this.state.data;
    const { LINE } = LINE_TYPE;
    const { k: K, d: D, j: J } = this.option.KDJ;
    this._drawLine(LINE, k, left, bottom, K.lineWidth, K.color);
    this._drawLine(LINE, d, left, bottom, D.lineWidth, D.color);
    this._drawLine(LINE, j, left, bottom, J.lineWidth, J.color);
  }
  _drawAxisY() {
    const {
      left,
      top,
      bottom,
      height,
      right
    } = this.availArea;
    const maxValue=this.maxValue
    const minValue=this.minValue
    // const line=Number(((Math.abs(this.maxValue)+Math.abs(this.minValue))/2).toFixed(2))
    let line;
    if(maxValue>0&&minValue<0){
      line=((Math.abs(maxValue)+Math.abs(minValue))/2+minValue).toFixed(2)
    }else if(maxValue<0&&minValue<0) {
      line=((Math.abs(minValue)-Math.abs(maxValue))/2+minValue).toFixed(2)
    }else {
      line=((Math.abs(maxValue)-Math.abs(minValue))/2+minValue).toFixed(2)
    }
    const ctx = this.context;
    ctx.beginPath();
    const { sizeRatio, fontFamily, color } = this.option.KDJ.axisY;
    ctx.font = sizeRatio * this.state.baseSize * this.dpr + 'px ' + fontFamily;
    ctx.strokeStyle = color;
    ctx.textAlign = 'left';
    ctx.textBaseline = 'top';
    ctx.fillText(maxValue.toFixed(2), left, top+20);
    ctx.textBaseline = 'middle';
    ctx.fillText(Number(line), left, top+height/2);
    ctx.textBaseline = 'bottom';
    ctx.fillText(minValue.toFixed(2), left, bottom);
  }
  // @checkMainTitleAuth
  _drawTitle() {
    const ctx2 = this.curContext;
    const { top } = this.availArea;
    const { current, sealObj } = this.state.data;
    const { height, baseSize } = this.state;
    const { ratioFixed } = sealObj;

    const { baseLine } = this.option.FootContext.title;
    const baseLineY = top + height * baseLine;
    let { left } = this.availArea;
    // left+=ctx2.measureText(this.maxValue.toFixed(2)).width+10
    const { space,sizeRatio,fontFamily } = this.option.KDJ;
    [
      'params',
      'k',
      'd',
      'j',
    ].forEach(val => {
      const data = this.state.data[val];
      if (data == 'KDJ(9,3,3)') {
        let color = this.option.KDJ.params.color

        ctx2.font = sizeRatio * baseSize * this.dpr + 'px ' + fontFamily;
        ctx2.fillStyle = color;
        ctx2.textAlign = 'left';
        ctx2.textBaseline = 'top';
        ctx2.beginPath();
        const text = data
        const textWidth = ctx2.measureText(text).width;
        ctx2.fillText(text, left, baseLineY);
        left += textWidth + 10;
      } else {
        if (Util.isArray(data)) {
          const {
            sizeRatio,
            fontFamily,
            color,
          } = this.option.KDJ[val];
          ctx2.font = sizeRatio * baseSize * this.dpr + 'px ' + fontFamily;
          ctx2.fillStyle = color;
          ctx2.textAlign = 'left';
          ctx2.textBaseline = 'top';
          ctx2.beginPath();
          const item = data[current];
          if (Util.isDef(item) && Util.isValidNumber(item.value)) {
            const text = val.toUpperCase() + ': ' + item.value.toFixed(ratioFixed);
            const textWidth = ctx2.measureText(text).width;
            ctx2.fillText(text, left, baseLineY);
            left += textWidth;
          } else {
            const text = val.toUpperCase() + ': -';
            const textWidth = ctx2.measureText(text).width;
            ctx2.fillText(text, left, baseLineY);
            left += textWidth;
          }
          left += space * this.dpr;
        }
      }
    })
  }
}
